export default {
    list: [{
            id: 1,
            name: 'Overview',
            icon: 'fal fa-info',
            route: {
                name: 'client.profile.overview',
            },
        },
        {
            id: 2,
            name: 'Communities',
            icon: 'fal fa-star',
            route: {
                name: 'client.profile.communities',
            },
        },
        {
            id: 3,
            name: 'Download GOZ',
            icon: 'fal fa-download',
            route: {
                name: 'client.profile.downloads',
            },
        },
        {
            id: 4,
            name: 'Transactions',
            icon: 'fal fa-receipt',
            route: {
                name: 'client.profile.transactions',
            },
        }, {
            id: 5,
            name: 'Packs Transactions',
            icon: 'fal fa-box-full',
            route: {
                name: 'client.profile.packs.transactions',
            },
        },
        {
            id: 6,
            name: 'Password',
            icon: 'fal fa-lock-alt',
            route: {
                name: 'client.profile.change.password',
            },
        },
        {
            id: 7,
            name: 'Settings',
            icon: 'fal fa-sliders-v-square',
            route: {
                name: 'client.profile.settings',
            },
        },
    ]
}
